<template>
  <div style="height: inherit">
    <b-modal
      v-model="modalShowAssign"
      size="sm"
      :title="titleModalAssign"
      ok-title="Guardar"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      no-close-on-esc
      :busy="isBusyAssign"
      :hide-footer="false"
      @ok="okMdlAssign"
    >
      <b-overlay
        :show="isBusyAssign"
        rounded="sm"
      >
        <pregunta-variable
          ref="refAssignForm"
          :is-busy-assign.sync="isBusyAssign"
          :modal-show.sync="modalShowAssign"
          :formula="formulaGenerada"
          :list-question="listQuestion"
          :type-action="typeActionAssign"
          @refresh-data="refreshDataVariable"
          @error-data="showError"
        />
      </b-overlay>
    </b-modal>
    <b-modal
      v-model="modalShowQuestion"
      size="lg"
      :title="titleModalQuestion"
      ok-title="Guardar"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      no-close-on-esc
      :busy="isBusyQuestion"
      :hide-footer="true"
      @ok="okMdlQuestion"
    >
      <b-overlay
        :show="isBusyQuestion"
        rounded="sm"
      >
        <pregunta-pad
          ref="refQuestionForm"
          :is-busy-question.sync="isBusyQuestion"
          :modal-show.sync="modalShowQuestion"
          :list-question="optionPadre"
          :type-action="typeAction"
          @refresh-data="refreshDataPadre"
          @error-data="showError"
        />
      </b-overlay>
    </b-modal>
    <b-sidebar
      id="add-new-user-sidebar"
      :visible="isAddNewUserSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      no-close-on-backdrop
      @hidden="resetForm"
      @change="(val) => toggleSidebar(val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5 class="mb-0">
            {{ titleForm }}
          </h5>

          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />

        </div>

        <!-- BODY -->
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >
            <validation-provider
              #default="validationContext"
              name="Bloque"
              rules="required"
            >
              <b-form-group
                label="Bloque"
                label-for="bloque"
                :state="getValidationState(validationContext)"
              >
                <b-form-select
                  v-model="bloque"
                  type="select"
                  class="custom-select"
                >
                  <option value="0">
                    NINGUNO::
                  </option>
                  <option
                    v-for="bloq in optionBloque"
                    :key="bloq.idBloque"
                    :value="bloq.idBloque"
                  >
                    {{ bloq.nombre }}
                  </option>
                </b-form-select>
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="validationContext"
              name="questionType"
              rules="required"
            >
              <b-form-group
                label-for="questionType"
              >
                <label for="popover-tipopregunta">Tipo Pregunta</label>
                <v-select
                  v-model="tipoPregunta"
                  placeholder=".: Seleccione Tipo Pregunta:."
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="optionTipoPregunta"
                  :reduce="m => m.idTipoPregunta"
                  label="questionType"
                  :clearable="false"
                  input-id="questionType"
                  @input="changeTipoPregunta"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider
              #default="validationContext"
              name="Enunciado"
              rules="required"
            >
              <b-form-group>
                <label for="enunciado">Enunciado </label>
                <small class="text-muted">
                  <i
                    class="popover-question"
                  >
                    <feather-icon
                      id="popover-enunciado"
                      icon="InfoIcon"
                      class="mr-50 fa-red"
                      @click="hidePopover"
                    />
                  </i>
                </small>
                <b-form-input
                  id="enunciado"
                  v-model="formData.enunciado"
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Escriba el enunciado de la pregunta.."
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <b-popover
              target="popover-enunciado"
              placement="top"
              triggers="hover"
            >
              <template #title>
                Definición de Enunciado
              </template>
              <span>
                Representa la información solicitada, se mostrará en los labels del aplicativo.
              </span>
            </b-popover>
            <validation-provider
              #default="validationContext"
              name="name"
              rules="required"
            >
              <b-form-group>
                <label for="name">Nombre </label>
                <small class="text-muted">
                  <i
                    class="popover-name"
                  >
                    <feather-icon
                      id="popover-name"
                      icon="InfoIcon"
                      class="mr-50 fa-red"
                      @click="hidePopover"
                    />
                  </i>
                </small>
                <b-form-input
                  id="name"
                  v-model="formData.name"
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Escriba el nombre de la pregunta.."
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <b-popover
              target="popover-name"
              placement="top"
              triggers="hover"
            >
              <template #title>
                Definición de Nombre
              </template>
              <span>
                Es un identificador de una pregunta.
              </span>
            </b-popover>
            <b-form-group
              v-show="showPlaceholder"
              label="Placeholder"
              label-for="bindFieldPlaceholder"
            >
              <b-form-input
                id="bindFieldPlaceholder"
                v-model="formData.bindFieldPlaceholder"
                trim
              />
            </b-form-group>
            <b-form-group
              v-show="showAppearance"
              label-for="appearance"
            >
              <label for="apariencia">Apariencia </label>
              <small class="text-muted">
                <i
                  class="popover-space"
                >
                  <feather-icon
                    id="popover-apariencia"
                    icon="InfoIcon"
                    class="mr-50 fa-red"
                    @click="hidePopover"
                  />
                </i>
              </small>
              <v-select
                v-model="apariencia"
                placeholder=".: Seleccione Tipo Pregunta:."
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionApariencia"
                :reduce="m => m.idApariencia"
                label="appearance"
                :clearable="false"
                input-id="appearance"
              />
            </b-form-group>
            <b-popover
              target="popover-apariencia"
              placement="top"
              triggers="hover"
            >
              <template #title>
                Definición de Apariencia
              </template>
              <span>
                Es la forma que se representará las preguntas. Entre los más usados tenemos: Minimal (input), multiline(textArea), signatura(Es usado para firmas siempre y cuando el tipo de pregunta es image)
              </span>
            </b-popover>
            <b-form-group
              v-show="!showNote"
            >
              <label class="col-sm-8 control-label">Requerido</label>
              <div
                class="col-sm-4 text-right"
                style="display:inline-block !important"
              >
                <b-form-checkbox
                  v-model="formData.requerido"
                  checked="true"
                  name="check-button"
                  switch
                  inline
                  @change="checkRequerido($event)"
                />
              </div>
            </b-form-group>
            <b-form-group
              v-show="false"
              label="Requerido Mensaje"
              label-for="requeridoMensaje"
            >
              <b-form-input
                id="requeridoMensaje"
                v-model="formData.requerido_msj"
                trim
              />
            </b-form-group>
            <b-form-group
              v-show="false"
            >
              <label for="choiceFilter">Filtro de Elección </label>
              <small class="text-muted">
                <i
                  class="popover-choiceFilter"
                >
                  <feather-icon
                    id="popover-choiceFilter"
                    icon="InfoIcon"
                    class="mr-50 fa-red"
                    @click="hidePopover"
                  />
                </i>
              </small>
              <b-form-input
                id="choiceFilter"
                v-model="formData.choiceFilter"
                trim
                placeholder="Escriba el nombre de la pregunta.."
              />
            </b-form-group>
            <b-popover
              target="popover-choiceFilter"
              placement="top"
              triggers="hover"
            >
              <template #title>
                Definición de Filtro de Elección ( choiceFilter )
              </template>
              <span>
                Representa el nombre de la pregunta qu se mostrrá en la encuesta.
              </span>
            </b-popover>
            <b-form-group
              v-show="showValueDefault"
            >
              <label for="defecto">Valor por Defecto </label>
              <small class="text-muted">
                <i
                  class="popover-space"
                >
                  <feather-icon
                    id="popover-defecto"
                    icon="InfoIcon"
                    class="mr-50 fa-red"
                    @click="hidePopover"
                  />
                </i>
              </small>
              <b-form-input
                id="defecto"
                v-model="formData.defecto"
                trim
              />
            </b-form-group>
            <b-popover
              target="popover-defecto"
              placement="top"
              triggers="hover"
            >
              <template #title>
                Definición de Valor por Defecto
              </template>
              <span>
                Por ejemplo: Al seleccionar la lista de paises, agregamos el valor por defecto PERÚ. Al pedir la edad de una persona, por defecto agregamos 8.
              </span>
            </b-popover>
            <b-form-group
              v-show="showNote"
              label="Cálculo"
              label-for="calculation"
            >
              <b-input-group>
                <b-form-input
                  id="calculation"
                  v-model="calculation"
                  trim
                  placeholder=""
                />
                <b-input-group-append
                  @click="seeVariables()"
                >
                  <b-button
                    variant="outline-primary"
                  >
                    <feather-icon
                      icon="CpuIcon"
                      size="13"
                      class="align-middle text-body"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group
              v-show="showBindType"
              label-for="bindType"
            >
              <label for="popover-campo">Tipo de Campo</label>
              <small class="text-muted">
                <i
                  class="popover-space"
                >
                  <feather-icon
                    id="popover-campo"
                    icon="InfoIcon"
                    class="mr-50 fa-red"
                    @click="hidePopover"
                  />
                </i>
              </small>
              <b-form-select
                id="bindType"
                v-model="bindType"
                type="select"
                class="custom-select"
              >
                <option value="">
                  SELECCIONE::
                </option>
                <option value="int">
                  int
                </option>
                <option value="decimal">
                  decimal
                </option>
                <option value="string">
                  string
                </option>
                <option value="time">
                  time
                </option>
                <option value="datetime">
                  datetime
                </option>
                <option value="date">
                  date
                </option>
              </b-form-select>
            </b-form-group>
            <b-popover
              target="popover-campo"
              placement="top"
              triggers="hover"
            >
              <template #title>
                Definición de Tipo de Campo
              </template>
              <span>
                Representa el tipo de datos permitido. Ejemplo: Al Seleccionar Integer, la pregunta dejará insertar sólo numeros enteros en el app.
              </span>
            </b-popover>
            <b-form-group
              v-show="showGroup"
              label="Grupo Opción"
              label-for="GrupoOpcion"
            >
              <v-select
                v-model="grupoOpcion"
                placeholder="NINGUNO"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionGrupoOpcion"
                :reduce="m => m.idGrupoOpcion"
                label="descripcion"
                :clearable="false"
                input-id="descripcion"
              />
            </b-form-group>
            <validation-provider
              #default="validationContext"
              name="Orden"
              rules="required"
            >
              <b-form-group
                label="Orden"
                label-for="orden"
                type="number"
              >
                <b-form-input
                  id="demo-sb"
                  v-model="orden"
                  min="1"
                  max="10000"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <b-form-group
              v-show="showLongCaract"
              label="Longitud de Caracteres"
              label-for="bindFieldLength"
              type="number"
            >
              <b-form-input
                id="demo-sb"
                v-model="bindFieldLength"
                min="1"
                max="10000"
              />
            </b-form-group>
            <b-form-group>
              <label class="col-sm-8 control-label">Condicional dependiente</label>
              <div
                class="col-sm-4 text-right"
                style="display:inline-block !important"
              >
                <b-form-checkbox
                  v-model="formData.condicionalDependiente"
                  checked="true"
                  name="check-button"
                  switch
                  inline
                  @change="checkCondicionalDependiente($event)"
                />
              </div>
            </b-form-group>
            <!-- <b-form-group
              v-show="isCondicionalDependiente"
              label-for="padre"
            >
              <label for="popover-padre">Padre</label>
              <b-form-input
                v-model="padre"
                readonly
                placeholder="Click para buscar lista de preguntas"
                style="cursor: pointer;"
                @click="clickPadre"
              />
            </b-form-group> -->
            <b-form-group
              v-show="isCondicionalDependiente"
              label-for="padre"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                class="mr-2"
                @click="clickPadre"
              >
                Buscar Preguntas
              </b-button>
            </b-form-group>
            <div
              v-show="isCondicionalDependiente"
              class="row"
            >
              <div class="col-md-12">
                <b-table
                  :items="itemsCondicion"
                  :fields="fieldsCondicion"
                  striped
                  responsive
                  :busy="isBusyCondicion"
                >
                  <template #cell(pregunta)="data">
                    <b-media vertical-align="center">
                      <b-link
                        class="font-weight-bold d-block text-nowrap"
                      >
                        {{ data.item.nombre }}
                      </b-link>
                      <small class="text-muted">{{ data.item.enunciado }}</small>
                    </b-media>
                  </template>
                  <template #cell(condicion)="data">
                    <b-form-input
                      id="nombre"
                      v-model="data.item.condicion"
                      trim
                      @keyup="calculateCondition"
                    />
                  </template>
                  <template #cell(op)="row">
                    <a
                      href="javascript:void(0)"
                      title="Eliminar"
                      @click.stop="deleteRow(row, 'delete')"
                    >
                      <feather-icon
                        icon="Trash2Icon"
                        class="mr-50 fa-red"
                      />
                    </a>
                  </template>
                </b-table>
              </div>
            </div>
            <b-form-group
              v-show="isCondicionalDependiente"
              label="Formula Condición"
            >
              <b-form-input
                v-model="idPadre"
                trim
                disabled
              />
            </b-form-group>
            <br>
            <div class="d-flex mt-3">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
                :disabled="isBusy"
              >
                Guardar
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
              >
                Cancelar
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import Vue from 'vue'
import router from '@/router'
import {
  BSidebar, BForm, BFormGroup, BOverlay, BFormInput, BInputGroup, BInputGroupAppend, BFormInvalidFeedback, BButton, BFormSelect, VBPopover, BPopover, BFormCheckbox, BTable,
  BMedia, BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import { _ } from 'vue-underscore'
import store from '@/store'
import { useNotify } from '@/helpers/toast'
import { avatarText } from '@core/utils/filter'
import PreguntaVariable from './PreguntaVariable.vue'
import PreguntaPad from './PreguntaPad.vue'
// import useUsersList from '../users-list/useUsersList'

export default {
  components: {
    BSidebar,
    BForm,
    BPopover,
    BFormGroup,
    BInputGroupAppend,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BOverlay,
    BFormCheckbox,
    BInputGroup,
    PreguntaVariable,
    PreguntaPad,
    BTable,
    BMedia,
    BLink,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  emits: ['update:data-edit'],
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    dataEdit: {
      type: Object,
      required: false,
      default: null,
    },
    listQuestion: {
      type: Array,
      default: () => [],
    },
    order: {
      type: Number,
      require: true,
      default: 1,
    },
    formType: {
      type: String,
      required: true,
    },
    idEncuesta: {
      type: Number,
      required: true,
    },
    imgLogo: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      required,
      avatarText,
    }
  },
  setup(props, context) {
    const { notify } = useNotify(context)
    const isCondicionalDependiente = ref(false)
    const padre = ref('')
    const idPadre = ref('')
    const bloque = ref(0)
    const titleForm = ref('')
    const grupoOpcion = ref('')
    const departamento = ref('')
    const optionBloque = ref([])
    const optionGrupoOpcion = ref([])
    const optionApariencia = ref([])
    const apariencia = ref('')
    const optionTipoPregunta = ref([])
    const showRequeridoMsj = ref(false)
    const showSelectGO = ref(true)
    const tipoPregunta = ref('')
    const refInputEl = ref(null)
    const previewEl = ref(null)
    const orden = ref(1)
    const bindFieldLength = ref(200)
    const bindType = ref('')
    const calculation = ref('')
    const isBusy = ref(false)
    const showLongCaract = ref(false)
    const showBindType = ref(false)
    const showValueDefault = ref(false)
    const showPlaceholder = ref(false)
    const showAppearance = ref(false)
    const showGroup = ref(false)
    const showNote = ref(false)
    const formulaGenerada = ref('')
    const optionPadre = ref([])
    /* modal */
    const modalShowAssign = ref(false)
    const titleModalAssign = ref('Gestión de Fórmula')
    const isBusyAssign = ref(false)
    const typeActionAssign = ref('Ver')
    const refAssignForm = ref(null)
    const refQuestionForm = ref(null)
    // MODAL DE PREGUNTAS
    const modalShowQuestion = ref(false)
    const titleModalQuestion = ref('Lista de Preguntas')
    const isBusyQuestion = ref(false)
    const typeAction = ref('show')
    const itemsCondicion = ref([])
    const fieldsCondicion = ref([
      { key: 'pregunta', label: 'Pregunta' },
      { key: 'condicion', thStyle: { width: '5px' } },
      { key: 'op', thStyle: { width: '5px' } },
    ])
    const isBusyCondicion = ref(false)
    const arrDetail = ref([])

    const showPopover = () => {
      context.emit('bv::show::popover', 'popover-enunciado')
      context.emit('bv::show::popover', 'popover-defecto')
    }
    const hidePopover = () => {
      context.emit('bv::hide::popover', 'popover-button-2')
    }
    const blankData = {
      name: '',
      enunciado: '',
      bindFieldPlaceholder: '',
      choiceFilter: '',
      calculation: '',
      bindType: '',
      orden: 1,
      requerido: '',
      requerido_msj: '',
      defecto: '',
      bindFieldLength: 200,
      condicionalDependiente: false,
    }
    const blankSelect = ''
    const blanckOrden = ''

    const formData = ref(JSON.parse(JSON.stringify(blankData)))/* desestructuracion de  blankData */
    const resetData = () => {
      formData.value = JSON.parse(JSON.stringify(blankData))
      bloque.value = JSON.parse(JSON.stringify(blankSelect))
      grupoOpcion.value = JSON.parse(JSON.stringify(blankSelect))
      tipoPregunta.value = JSON.parse(JSON.stringify(blankSelect))
      apariencia.value = JSON.parse(JSON.stringify(blankSelect))
      orden.value = JSON.parse(JSON.stringify(blanckOrden))
      bindFieldLength.value = JSON.parse(JSON.stringify(blanckOrden))
      bindType.value = JSON.parse(JSON.stringify(blanckOrden))
      calculation.value = JSON.parse(JSON.stringify(blanckOrden))
    }
    const cleanPadre = () => {
      console.log('clean')
      padre.value = ''
      idPadre.value = ''
    }
    const seeVariables = () => {
      modalShowAssign.value = true
      formulaGenerada.value = calculation.value
      titleModalAssign.value = 'Gestión de Formulas'
    }
    const okMdlAssign = ev => {
      ev.preventDefault()
      refAssignForm.value.saveForm()
    }
    const okMdlQuestion = ev => {
      ev.preventDefault()
      refQuestionForm.value.saveForm()
    }
    const clickPadre = () => {
      modalShowQuestion.value = true
      titleModalQuestion.value = 'Lista de Preguntas'
    }
    const calculateCondition = () => {
      idPadre.value = ''
      itemsCondicion.value.forEach(da => {
        idPadre.value += `${da.idPadre}-${da.condicion.toUpperCase()}***`
      })
      idPadre.value = idPadre.value.slice(0, idPadre.value.length - 3)
    }
    const onSubmit = () => {
      let stateName = false
      let bval = true
      if (props.listQuestion.length > 0) {
        props.listQuestion.forEach(dat => {
          if (dat.name === formData.value.name) {
            stateName = true
          }
        })
      }
      if (stateName && props.formType !== 'edit') {
        notify('Advertencia', 'Ya existe un pregunta con ese nombre', 'warning')
        bval = false
      }
      if (bval && tipoPregunta.value === '') {
        notify('Advertencia', 'Seleccione un tipo de pregunta', 'warning')
        bval = false
      }
      if (bval && apariencia.value === '') {
        notify('Advertencia', 'Seleccione un apariencia', 'warning')
        bval = false
      }
      /* if (bval && bindType.value === '') {
        notify('Advertencia', 'Seleccione un tipo de dato', 'warning')
        bval = false
      } */
      if (bval) {
        isBusy.value = true
        formData.value.bloque = {
          idBloque: bloque.value,
        }
        formData.value.tipoPregunta = {
          idTipoPregunta: tipoPregunta.value,
        }
        formData.value.apariencia = {
          idApariencia: apariencia.value,
        }
        formData.value.encuesta = {
          idEncuesta: props.idEncuesta,
        }
        formData.value.bindType = (bindType.value === '') ? '' : bindType.value // bindType
        formData.value.orden = orden.value
        formData.value.bindFieldLength = bindFieldLength.value
        formData.value.calculation = calculation.value
        const idPGO = (formData.value.preguntaGrupoOpcion !== undefined && formData.value.preguntaGrupoOpcion[0]) ? formData.value.preguntaGrupoOpcion[0].idPreguntaGrupoOpcion : 0
        const idGO = grupoOpcion.value
        formData.value.preguntaGrupoOpcion = [
          {
            idPreguntaGrupoOpcion: (idGO === '') ? 0 : idPGO,
            grupoOpcion: {
              idGrupoOpcion: (idGO === '') ? 0 : idGO,
            },
          },
        ]
        formData.value.formulaCondicion = idPadre.value

        let service = 'gsencuesta/PREGUNTA_CREATE'
        if (props.formType === 'edit') {
          service = 'gsencuesta/PREGUNTA_UPDATE'
        }
        store.dispatch(service, formData.value)
          .then(response => {
            isBusy.value = false
            context.emit('refetch-data', response)
            context.emit('update:is-add-new-user-sidebar-active', false)
          })
          .catch(error => {
            isBusy.value = false
            notify('Ha ocurrido un error', error.response.data.message, 'danger')
          })
      }
    }
    const getApariencia = async idTipoPregunta => {
      await store
        .dispatch('gsencuesta/APARIENCIA_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: 'idApariencia%7CASC',
        })
        .then(response => {
          if (response !== undefined) {
            // optionApariencia.value = response
            // apariencia.value = 4
            optionApariencia.value = []
            if (idTipoPregunta === 12 || idTipoPregunta === 4) {
              if (idTipoPregunta === 4) {
                response.forEach(dat => {
                  if (dat.idApariencia === 4 || dat.idApariencia === 10) {
                    optionApariencia.value.push(dat)
                  }
                })
                if (props.formType !== 'edit') {
                  apariencia.value = 4
                }
              } else {
                response.forEach(dat => {
                  if (dat.idApariencia === 11 || dat.idApariencia === 12 || dat.idApariencia === 13 || dat.idApariencia === 14) {
                    optionApariencia.value.push(dat)
                  }
                })
                if (props.formType !== 'edit') {
                  apariencia.value = 11
                }
              }
            } else {
              optionApariencia.value = response
              if (props.formType !== 'edit') {
                apariencia.value = 4
              }
            }
          }
        })
        .catch(() => {
        })
    }
    const dataForm = () => {
      store
        .dispatch('gsencuesta/TIPO_PREGUNTA_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: 'idTipoPregunta%7CASC',
        })
        .then(response => {
          if (response !== undefined) {
            optionTipoPregunta.value = response
          }
        })
        .catch(() => {
        })
      store
        .dispatch('gsencuesta/APARIENCIA_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: 'idApariencia%7CASC',
        })
        .then(response => {
          if (response !== undefined) {
            optionApariencia.value = response
            apariencia.value = 4
          }
        })
        .catch(() => {
        })
      store
        .dispatch('gsencuesta/BLOQUE_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          idEncuesta: router.currentRoute.params.id,
          sortBy: 'idBloque%7CASC',
        })
        .then(response => {
          if (response !== undefined) {
            optionBloque.value = response
          }
        })
        .catch(() => {
        })
      const grupoOpcionDefault = {
        id: '',
        descripcion: 'NINGUNO',
      }
      store
        .dispatch('gsencuesta/GRUPO_OPCION_FIND_ALL', {
          limit: -1,
          query: '',
          page: -1,
          sortBy: '',
          padre: 0, // PADRE DE SUBCATEGORÍA
        })
        .then(response => {
          if (response !== undefined) {
            optionGrupoOpcion.value = response
            optionGrupoOpcion.value.unshift(grupoOpcionDefault)
          }
        })
        .catch(() => {
        })
    }
    const checkRequerido = value => {
      if (value) {
        showRequeridoMsj.value = true
      } else {
        showRequeridoMsj.value = false
      }
    }
    const checkCondicionalDependiente = val => {
      if (val) {
        isCondicionalDependiente.value = true
      } else {
        isCondicionalDependiente.value = false
      }
    }
    const changeTipoPreguntaGet = async val => {
      if (val === 5 || val === 6 || val === 7 || val === 11 || val === 12 || val === 13) {
        showLongCaract.value = false
        showBindType.value = false
        showValueDefault.value = false
        if (val === 5 || val === 6 || val === 7 || val === 11 || val === 13) {
          showAppearance.value = false
          showPlaceholder.value = false
        } else {
          // apariencia.value = 4
          showAppearance.value = true
          if (val === 12) {
            showPlaceholder.value = false
          } else {
            showPlaceholder.value = true
          }
        }
        if (val === 5 || val === 6) {
          showGroup.value = true
        } else {
          showGroup.value = false
        }
        if (val === 7) {
          showNote.value = true
        } else {
          showNote.value = false
        }
        if (val === 11) { // Date
          showBindType.value = true
          bindType.value = 'date'
        } else {
          showBindType.value = false
        }
      } else {
        showLongCaract.value = true
        showBindType.value = true
        showValueDefault.value = true
        showPlaceholder.value = true
        showGroup.value = false
        if (val === 1 || val === 2) {
          showAppearance.value = false
        } else {
          showAppearance.value = true
        }
        if (val === 1 || val === 2 || val === 4) {
          showBindType.value = false
        } else {
          showBindType.value = true
        }
        switch (val) {
          case 1: bindType.value = 'int'; break
          case 2: bindType.value = 'decimal'; break
          case 11: bindType.value = 'date'; break
          default: bindType.value = 'string'
        }
      }
      /* if (val === 15) {
        isCondicionalDependiente.value = true
      } else {
        isCondicionalDependiente.value = false
      } */
    }
    const changeTipoPregunta = async val => {
      await changeTipoPreguntaGet(val)
      await getApariencia(tipoPregunta.value)
    }
    const findData = async () => {
      await store
        .dispatch('gsencuesta/PREGUNTA_FIND', { id: props.dataEdit.idPregunta })
        .then(response => {
          if (response !== undefined) {
            tipoPregunta.value = response.tipoPregunta.idTipoPregunta
            formData.value = {
              idPregunta: response.idPregunta,
              enunciado: response.enunciado,
              name: response.name,
              preguntaGrupoOpcion: response.preguntaGrupoOpcion,
              orden: response.orden,
              requerido: response.requerido,
              requerido_msj: response.requerido_msj,
              defecto: response.defecto,
              bindFieldPlaceholder: response.bindFieldPlaceholder,
              condicionalDependiente: response.condicionalDependiente,
            }
            grupoOpcion.value = (response.preguntaGrupoOpcion[0]) ? response.preguntaGrupoOpcion[0].grupoOpcion.idGrupoOpcion : ''

            bindFieldLength.value = response.bindFieldLength
            calculation.value = response.calculation
            orden.value = response.orden
            apariencia.value = response.apariencia.idApariencia
            bloque.value = response.bloque.idBloque
            bindType.value = response.bindType
            if (response.requerido) {
              showRequeridoMsj.value = true
            }
            titleForm.value = 'Editar Pregunta'
          }
        })
        .catch(() => {
        })
    }
    const deleteRow = row => {
      Vue.swal({
        title: 'Está seguro?',
        text: 'Va eliminar un registro!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          itemsCondicion.value.splice(row.index, 1)
          arrDetail.value = _.reject(arrDetail.value, item => item === row.item.idPadre)
          calculateCondition()
        }
        // console.log(arrDetail.value)
      })
    }

    const toggleSidebar = async val => {
      showRequeridoMsj.value = false
      showSelectGO.value = true
      orden.value = props.order + 1
      bindFieldLength.value = 200
      bindType.value = ''
      calculation.value = ''
      showLongCaract.value = false
      showBindType.value = false
      showValueDefault.value = false
      showPlaceholder.value = false
      showAppearance.value = false
      showGroup.value = false
      showNote.value = false
      isCondicionalDependiente.value = false
      idPadre.value = ''
      padre.value = ''
      itemsCondicion.value = []
      idPadre.value = ''
      await dataForm()
      context.emit('update:is-add-new-user-sidebar-active', val)
      bloque.value = 0
      // tipoPregunta.value = 4
      if (props.formType === 'new') {
        apariencia.value = 4
        titleForm.value = 'Agregar Pregunta'
      }
      if (props.formType === 'edit') {
        await getApariencia(props.dataEdit.tipoPregunta.idTipoPregunta)
        await changeTipoPreguntaGet(props.dataEdit.tipoPregunta.idTipoPregunta)
        await findData()
        /* if (props.dataEdit.tipoPregunta.idTipoPregunta === 15) { // CONDICIONAL DEPENDIENTE
          if (props.listQuestion.length > 0) {
            props.listQuestion.forEach(dat => {
              if (dat.idPregunta === props.dataEdit.idPadre) {
                idPadre.value = props.dataEdit.idPadre
                padre.value = dat.enunciado
              }
            })
          }
        } */
        /** CALCULANDO FORMULA */
        if (props.dataEdit.condicionalDependiente && props.dataEdit.tipoPregunta.idTipoPregunta && props.dataEdit.formulaCondicion.length > 0) {
          // if (props.dataEdit.tipoPregunta.idTipoPregunta && props.dataEdit.formulaCondicion.length > 0) {
          if (props.listQuestion.length > 0) {
            const arr1 = props.dataEdit.formulaCondicion.split('***')
            itemsCondicion.value = []
            arr1.forEach((dat, index) => {
              const arr2 = dat.split('-')
              const filterPreg = _.findWhere(props.listQuestion, { idPregunta: Number(arr2[0]) })
              const row = {
                index,
                idPadre: arr2[0],
                enunciado: filterPreg.enunciado,
                nombre: filterPreg.name,
                condicion: arr2[1],
              }
              itemsCondicion.value.push(row)
            })
            idPadre.value = props.dataEdit.formulaCondicion
            isCondicionalDependiente.value = true
          }
        }
      }
    }
    const refreshDataVariable = response => {
      calculation.value = response
    }
    const refreshDataPadre = response => {
      const row = {
        index: 0,
        idPadre: response.idPregunta,
        enunciado: response.enunciado,
        nombre: response.name,
        condicion: 'SI',
      }
      if (!_.contains(arrDetail.value, row.idPadre)) {
        itemsCondicion.value.push(row)
        idPadre.value = ''
        itemsCondicion.value.forEach((da, i) => {
          itemsCondicion.value[i].index = i
          idPadre.value += `${da.idPadre}-${da.condicion}***`
        })
        idPadre.value = idPadre.value.slice(0, idPadre.value.length - 3)
        arrDetail.value.push(row.idPadre)
      } else {
        notify('Advertencia', 'Este pregunta ya fue asignada', 'warning')
      }
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    return {
      departamento,
      formData,
      optionBloque,
      optionGrupoOpcion,
      showRequeridoMsj,
      showSelectGO,
      titleForm,
      onSubmit,
      checkRequerido,
      toggleSidebar,
      refFormObserver,
      getValidationState,
      resetForm,
      bloque,
      refInputEl, // PARA RELACIONAR BOTON CON INPUT FILE
      previewEl,
      orden,
      bindType,
      bindFieldLength,
      calculation,
      tipoPregunta,
      grupoOpcion,
      changeTipoPregunta,
      showPopover,
      hidePopover,
      isBusy,
      optionApariencia,
      optionTipoPregunta,
      apariencia,
      seeVariables,
      modalShowAssign,
      titleModalAssign,
      isBusyAssign,
      typeActionAssign,
      okMdlAssign,
      formulaGenerada,
      refAssignForm,
      refreshDataVariable,
      showLongCaract,
      showBindType,
      showValueDefault,
      showAppearance,
      showPlaceholder,
      showGroup,
      showNote,
      optionPadre,
      isCondicionalDependiente,
      clickPadre,
      modalShowQuestion,
      titleModalQuestion,
      isBusyQuestion,
      typeAction,
      okMdlQuestion,
      refQuestionForm,
      refreshDataPadre,
      idPadre,
      padre,
      cleanPadre,
      itemsCondicion,
      fieldsCondicion,
      isBusyCondicion,
      deleteRow,
      calculateCondition,
      checkCondicionalDependiente,
    }
  },
  methods: {
    refetchData(response) {
      let message = 'El proceso se ha ejecutado satisfactoriamente.'
      if (response.message) {
        message = response.message
      }
      this.$bvToast.toast(message, {
        title: 'Operación Extitosa',
        variant: 'success',
        solid: true,
      })
      this.listarRegistros()
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.errorMessage
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
.popover-question {
  margin-left: 1%;
  cursor: pointer;
}
</style>
